angular.module('galilai.creator').controller('ImportController', function($scope, $rootScope, api, visual, parserService, $timeout) {

    // TODO - Hardcoded
    const BASE_SIZE = 350
    const SHOULD_CLEAN_SPAN_COLORS = false
    $scope.features = {
        import_advanced: false,
    }

    $scope.classification = []

    const INITIAL_VIEW = {
        colors: [],
        numberPages: 1,
        editingLanguage: 'en',
        editingTemplate: false,
        availableLanguages: [
            {
                value: 'en',
                name: window._LANGUAGES['en'],
            },
            {
                value: 'pt',
                name: window._LANGUAGES['pt'],
            }
        ],
        types: [
            {
                name: gettext('label.import_tabs_text'),
                value: 'text'
            },
            {
                name: gettext('label.import_tabs_image'),
                value: 'image'
            },
            {
                name: gettext('label.import_tabs_background'),
                value: 'background'
            },
            {
                name: gettext('label.import_tabs_colors'),
                value: 'colors'
            },
            {
                name: gettext('label.import_tabs_fonts'),
                value: 'fonts'
            }
        ],
        currentContent: {},
        postSize: 'portrait',
        selectedLayer: null,
        selectedType: 'text',
        currentLayers: [],
        mappingKinds: {},
        mappingRules: {},
        theme: BASE_THEME,
        mainBrandKit: null,
        availableValues: {
            fonts: [],
            colors: [],
        },
        availableOptions: {
            'text': [
                {
                    name: gettext('label.import_option_title'),
                    value: 'title'
                },
                {
                    name: gettext('label.import_option_description'),
                    value: 'description'
                },
                {
                    name: gettext('label.import_option_fixed_text'),
                    value: 'fixed_text'
                },
                {
                    name: gettext('label.import_option_phone'),
                    value: 'phone'
                },
                {
                    name: gettext('label.import_option_email'),
                    value: 'email'
                },
                {
                    name: gettext('label.import_option_address'),
                    value: 'address'
                },
                {
                    name: gettext('label.import_option_website'),
                    value: 'website'
                },
                {
                    name: gettext('label.import_number'),
                    value: 'number'
                },
                {
                    name: gettext('label.import_author_handle'),
                    value: 'author.handle'
                },
            ],
            'image': [
                {
                    name: gettext('label.import_option_main_image'),
                    value: 'main_image'
                },
                {
                    name: gettext('label.import_option_person_image'),
                    value: 'person_image'
                },
                {
                    name: gettext('label.import_option_fixed_image'),
                    value: 'fixed_image'
                },
                {
                    name: gettext('label.import_option_contextual_fixed_image'),
                    value: 'contextual_fixed_image'
                },
            ],
            'colors': [
                {
                    name: gettext('label.import_option_main_color'),
                    value: 'main'
                },
                {
                    name: gettext('label.import_option_text_color'),
                    value: 'text'
                },
                {
                    name: gettext('label.import_option_highlight_color'),
                    value: 'highlight'
                },
            ],
            'fonts': [
                {
                    name: gettext('label.import_option_font_title'),
                    value: 'title'
                },
                {
                    name: gettext('label.import_option_font_body'),
                    value: 'body'
                },
                {
                    name: gettext('label.import_option_font_subtitle'),
                    value: 'subtitle'
                },
            ],
            'background': [
            ]
        }
    }

    const SAMPLE_CONTENT = {
        title: '<em style="font-size:6rem;display:block;font-weight:bold;line-height: normal;font-style:normal;color:#HIGHLIGHT" class="number-highlight">5</em> técnicas secretas para superar a procrastinação e turbinar sua produtividade',
        description: 'A procrastinação é um dos maiores inimigos da produtividade.',
        image: 'https://images.pexels.com/photos/5200784/pexels-photo-5200784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
        author: {
            handle: '@_galilai',
        }
    }

    $scope.importTodo = [
        'Map text fields',
        'Merge text',
        'Needs to have handle',
        'Handle needs spacing',
        'Map images',
        'Map colors',
        'Map fonts',
        'Choose area',
        'Choose objective',
        'Choose shapes/dimension',
        'Preview',
    ]

    $scope.view = JSON.parse(JSON.stringify(INITIAL_VIEW))

    $rootScope.$on('onUserData', function(event, args) {
        if (args.features && args.features.import_templates_advanced) {
            $scope.features.import_advanced = true
        }
    })

    $rootScope.$on('openImport', function(event, data){
        $scope.importURL = null
        $scope.cleanImport()

        if (data.projectId) {
            $scope.projectId = data.projectId
        }
        if (data.id) {
            $scope.view.editingTemplate = true
            $scope.editTemplate(data.id)
        }
        $scope.importAsStyle = !!data.style
        $scope.isDuplicate = !!data.duplicate
        $scope.getCategories()
    })

    $scope.layouts = []
    $scope.parsedPosts = []

    $scope.isAdvanced = function() {
        return $scope.features.import_advanced
    }

    $scope.isStyle = function() {
        return $scope.importAsStyle
    }

    $scope.selectType = function(type) {
        $scope.view.selectedType = type
        $scope.updateLayers()
    }

    $scope.isBrandKitTab = function() {
        return $scope.view.selectedType === 'colors' || $scope.view.selectedType === 'fonts'
    }

    $scope.shouldHideBrandKit = function(type) {
        if ($scope.isStyle() && (type.value != 'colors' && type.value != 'fonts')) {
            return true
        }
        if (!$scope.view.pages) {
            return true
        }
        let active = $scope.view.pages.find(p => p.active)
        return (type.value === 'colors' || type.value === 'fonts') && $scope.view.pages && active && active.id > 0
    }

    function updateMapping() {
        let requiredMappingKinds = ['number']
        // Iterate over all elements and add key replace with value from mappingKinds (mapping kinds is id: type)
        let mappingKinds = $scope.view.mappingKinds
        function updateElements(tree) {
            for (let element of tree.elements) {
                if (mappingKinds[element.id]) {
                    element.replace = mappingKinds[element.id];
                    if (requiredMappingKinds.includes(mappingKinds[element.id])) {
                        element.required = true;
                    }
                } else {
                    delete element.replace;
                    delete element.required;
                }
                if (element.elements) {
                    updateElements(element);
                }
            }
        }
        updateElements($scope.layout.tree);
    }
    $scope.onMappingChange = function(id, value) {
        const uniqueValues = [
            'main_image',
            //'title',
            'description',
        ]
        const defaultValues = {
            'text': 'fixed_text',
            'image': 'fixed_image',
        }
        if (uniqueValues.includes(value)) {
            // Then unset from other mappings and update id with value
            for (let key in $scope.view.mappingKinds) {
                if ($scope.view.mappingKinds[key] === value) {
                    $scope.view.mappingKinds[key] = defaultValues[$scope.view.selectedType]
                }
            }
        }
        $scope.view.mappingKinds[id] = value
        updateMapping()
    }

    function getBackgroundColors(elements, colors) {
        let backgrounds = elements.filter(e => e.type === 'rect')
        // Sort backgrounds by area
        backgrounds.sort(function(a, b) {
            return parseFloat(b.computed.width) * parseFloat(b.computed.height) - parseFloat(a.computed.width) * parseFloat(a.computed.height)
        })

        for (let background of backgrounds) {
            if (background.computed.background) {
                let color = background.computed.background.split(')')[0]
                let rgb = color.match(/\d+/g)
                if (rgb) {
                    let hex = RGBToHEX(...rgb)
                    if (!colors.includes(hex)) {
                        colors.push(hex)
                    }
                }
            }
        }
        return Array.from(new Set(colors))
    }
    function getTextColors(elements, colors) {
        let texts = elements.filter(e => e.type === 'p' || e.type === 'h1')
        // Sort backgrounds by area
        texts.sort(function(a, b) {
            return parseFloat(b.computed['font-size']) - parseFloat(a.computed['font-size'])
        })

        for (let text of texts) {
            if (text.computed.color) {
                let color = text.computed.color.split(')')[0]
                let rgb = color.match(/\d+/g)
                if (rgb) {
                    let hex = RGBToHEX(...rgb)
                    if (!colors.includes(hex)) {
                        colors.push(hex)
                    }
                }
            }
        }
        return Array.from(new Set(colors))
    }

    function getSVGColors(elements, colors) {
        let svgs = elements.filter(e => e.type === 'image' && e.content && e.content.includes('<svg') || e.type === 'svg')
        let foundColors = []
        for (let svg of svgs) {
            let parser = new DOMParser()
            let doc = parser.parseFromString(svg.content, 'image/svg+xml')
            let paths = doc.querySelectorAll('path')
            for (let path of paths) {
                if (path.getAttribute('fill')) {
                    foundColors.push(path.getAttribute('fill'))
                }
                if (path.getAttribute('stroke')) {
                    foundColors.push(path.getAttribute('stroke'))
                }
                // also read from style
                if (path.style.fill) {
                    foundColors.push(path.style.fill)
                }
                if (path.style.stroke) {
                    foundColors.push(path.style.stroke)
                }
            }
            // All query for <stop> elements
            let stops = doc.querySelectorAll('stop')
            for (let stop of stops) {
                if (stop.getAttribute('stop-color')) {
                    foundColors.push(stop.getAttribute('stop-color'))
                }
                if (stop.style['stop-color']) {
                    foundColors.push(stop.style['stop-color'])
                }
            }
            // Also read from style computed
            if (svg.computed.fill) {
                foundColors.push(svg.computed.fill)
            }
            if (svg.computed.stroke) {
                foundColors.push(svg.computed.stroke)
            }
        }
        // Remove duplicates
        foundColors = Array.from(new Set(foundColors))
        // Convert to HEX
        foundColors = foundColors.map(color => {
            if (color.indexOf('#') === 0) {
                return color
            }
            let rgb = color.match(/\d+/g)
            if (rgb) {
                return RGBToHEX(...rgb)
            }
            return null
        }).filter(color => color)

        // Add to colors only if not already there
        for (let color of foundColors) {
            if (!colors.includes(color)) {
                colors.push(color)
            }
        }
        return colors
    }

    $scope.updateLayers = function() {
        // Iterate recursevely trhough scope.layout.tree and get all nodes of type $scope.view.selectedType
        let layers = []
        let type = $scope.view.selectedType
        if (!type) {
            return
        }
        // TODO - Refactor
        let tree = $scope.layout.tree
        let mapTypes = {
            'text': ['p', 'h1'],
            'image': ['image'],
            'background': ['rect'],
            'fonts': ['p', 'h1'],
            'colors': ['rect', 'p', 'h1', 'image', 'svg'],
        }
        let backgrounds = []
        function getLayers(tree, type) {
            for (let element of tree.elements) {
                if (mapTypes[type].includes(element.type)) {
                    if (element.type === 'p' || element.type === 'h1') {
                        if (element.value) {
                            let value = element.value
                            // Clean values
                            if (SHOULD_CLEAN_SPAN_COLORS) {
                                value = value.replace(/color: rgb\([^)]+\)/g, '')
                                if (value.indexOf('style=""') > -1 || value.indexOf('style=\'\'') > -1) {
                                    value = value.replace(/<[^>]*>?/gm, '')
                                }
                            }
                            element.value = value
                            layers.push(element)
                        }
                    } else {
                        layers.push(element)
                    }
                } else if (mapTypes[type].length === 0) {
                    layers.push(element)
                }
                if (element.type === 'rect') {
                    backgrounds.push(element)
                }
                if (element.elements) {
                    getLayers(element, type)
                }
            }
        }

        getLayers(tree, type)

        $timeout(angular.noop)
        $scope.render()

        if (type === 'fonts') {
            let fonts = []
            let fontMap = {}
            for (element of layers) {
                if (element.computed['font-family'] && !fontMap[element.computed['font-family']]) {
                    let clone = JSON.parse(JSON.stringify(element))
                    clone.originalId = clone.id
                    delete clone.id
                    clone.id = element.computed['font-family']
                    fonts.push({
                        value: element.computed['font-family'].replace(/"/g, ''),
                        name: element.value.replace(/<[^>]*>?/gm, ''),
                        originalId: clone.originalId,
                    })
                    fontMap[element.computed['font-family']] = true
                }
            }
            // Init brand kit from mapping kind
            if (!$scope.layout.brandKit) {
                $scope.layout.brandKit = {}
            }
            if (!$scope.layout.brandKit[type]) {
                $scope.layout.brandKit[type] = {}
            }
            // Map text kinds to fonts kinds
            let mappingTextFontsKinds = {
                'title': 'title',
                'description': 'body',
            }
            for (let layer of fonts) {
                if (!$scope.layout.brandKit[type][layer.id] && $scope.view.mappingKinds[layer.originalId]) {
                    let kind = $scope.view.mappingKinds[layer.originalId]
                    if (mappingTextFontsKinds[kind] && !$scope.layout.brandKit[type][mappingTextFontsKinds[kind]]) {
                        $scope.layout.brandKit[type][mappingTextFontsKinds[kind]] = layer.value
                    }
                }
            }
            layers = []
            $scope.view.availableValues.fonts = fonts
        } else if (type === 'colors') {
            let colors = getBackgroundColors(layers, [])
            colors = getTextColors(layers, colors)
            colors = getSVGColors(layers, colors)

            layers = colors.map(function(color) {
                return {
                    value: color,
                }
            })
            if (!$scope.layout.brandKit) {
                $scope.layout.brandKit = {}
            }
            if (!$scope.layout.brandKit[type]) {
                $scope.layout.brandKit[type] = {}
            }
            if (!$scope.layout.brandKit[type]['pallete']) {
                $scope.layout.brandKit[type]['pallete'] = []
            }
            $scope.layout.brandKit[type]['pallete'] = colors
            $scope.view.availableValues.colors = layers
            layers = []
        }
        updateMapping()
        $scope.view.currentLayers = layers
    }

    $scope.selectLayerById = function(id) {
        console.log('Selecting layer', id)
        let element = findElementsById($scope.layout.tree, id)
        if (element) {
            $scope.view.selectedLayer = element
        }
    }

    $scope.selectLayoutColor = function(color) {
        if (getActiveElement()) {
            let element = getActiveElement()
            if (element.type === 'rect') {
                element.computed.background = color
            } else if (element.type === 'p' || element.type === 'h1') {
                element.computed.color = color
            }
            $scope.refresh()
            return
        }
    }

    $scope.getBackgroundStyle = function(element) {
        if (!element || !element.computed.background) {
            return null
        }
        let maxSize = 60
        let width = parseFloat(element.computed.width)
        let height = parseFloat(element.computed.height)
        let scale = 1
        if (width > height) {
            scale = maxSize / width
        } else {
            scale = maxSize / height
        }
        return {
            width: width * scale,
            height: height * scale,
            background: element.computed.background,
            border: '1px solid #ccc',
        }
    }

    $scope.updateTextValues = function(initial) {
        let textMap = {}
        document.querySelectorAll('[data-text-import-id]').forEach(function(element) {
            textMap[element.getAttribute('data-text-import-id')] = element.innerHTML
        })

        if (!$scope.layout.translation.original || !$scope.view.editingLanguage) {
            return
        }
        if (initial && $scope.layout.translation[$scope.view.editingLanguage]) {
            return
        }
        $scope.layout.translation[$scope.view.editingLanguage] = textMap

        if (initial) {
            return
        }
        $scope.onChangeEditingLanguage()
    }

    $scope.onChangeEditingLanguage = function() {
        $scope.updateTextValues(true)

        let mapTypes = {
            'text': ['p', 'h1'],
        }
        function updateLayers(tree) {
            for (let element of tree.elements) {
                if (mapTypes['text'].includes(element.type)) {
                    if (element.type === 'p') {
                        if ($scope.view.editingLanguage === $scope.layout.translation.original && $scope.layout.translation[$scope.layout.translation.original] && $scope.layout.translation[$scope.layout.translation.original][element.id]) {
                            // Reset to original
                            element.value = $scope.layout.translation[$scope.layout.translation.original][element.id]
                        } else if ($scope.layout.translation[$scope.view.editingLanguage] && $scope.layout.translation[$scope.view.editingLanguage][element.id]) {
                            let originalValue = element.value
                            if (!$scope.layout.translation[$scope.layout.translation.original]) {
                                $scope.layout.translation[$scope.layout.translation.original] = {}
                            }
                            // Set original only once
                            if (!$scope.layout.translation[$scope.layout.translation.original][element.id]) {
                                $scope.layout.translation[$scope.layout.translation.original][element.id] = originalValue
                            }
                            element.value = $scope.layout.translation[$scope.view.editingLanguage][element.id]
                        }
                    }
                }
                if (element.elements) {
                    updateLayers(element)
                }
            }
        }
        updateLayers($scope.layout.tree)
        $scope.updateLayers()
        $scope.render()
        $timeout(angular.noop)
    }

    $scope.refresh = function() {
        $scope.updateLayers()
        $scope.render()

        if (!visual) {
            return
        }
        if (!$scope.view.selectedLayer) {
            return
        }
        $timeout(function() {
            visual.selectElement({
                elementId: $scope.view.selectedLayer.id,
                cardId: '0',
            })
        })
    }

    $scope.onInputsChange = function() {
        $scope.refresh()
    }

    $scope.getCategories = function() {
        api.getImporterCategories().then(function(res) {
            function convertValues(item) {
                let row = {
                    value: item.key,
                    label: item.name,
                }
                return row
            }
            let data = res.data
            data.areas = data.areas.map(convertValues)
            data.areas.push({
                value: 'generic',
                label: 'Default',
            })
            data.categories = data.categories.map(convertValues)
            data.professions = data.professions.map(convertValues)
            data.objectives = data.objectives.map(convertValues)
            for (style of data.styles) {
                style.values = style.values.map(convertValues)
            }

            if ($scope.isStyle()) {
                data.styles = data.styles.filter(style => style.id == 'gender')
            }
            $scope.classification = data
        })
        .catch(function() {

        })
    }

    $scope.init = function() {
    }

    $scope.view.pages = []

    $scope.selectPage = function(page) {
        $scope.view.pages = $scope.view.pages.map(function(p) {
            p.active = p.id === page.id
            return p
        })

        delete $scope.view.originalLayout
        if ($scope.layouts[page.id]) {
            $scope.layout = $scope.layouts[page.id]
            if ($scope.layout.mapping || $scope.layout.dynamicMap) {
                $scope.view.mappingKinds = $scope.layout.mapping || $scope.layout.dynamicMap
            } else {
                $scope.view.mappingKinds = {}
            }
            if (!$scope.layout.classification) {
                $scope.layout.classification = {}
            }
            $scope.render()
            $scope.updateLayers()
            return
        }
        $scope.openImport($scope.importId)
    }

    $scope.createPages = function(number) {
        $scope.view.pages = Array.from({length: number}, (v, k) => k).map(function(index) {
            return {
                title: `Slide ${index + 1}`,
                id: index,
                active: index === 0,
            }
        })
    }

    $scope.openImport = function(importId) {
        if (!$scope.view.pages || $scope.view.pages.length === 0) {
            $scope.createPages(1)
        }
        let currentPageId = $scope.view.pages.find(p => p.active).id

        api.getImportLayout(importId, currentPageId).then(function(response) {
            $scope.view.editingLanguage = response.data.layout.translation.original
            $scope.layouts[currentPageId] = response.data.layout
            $scope.layout = response.data.layout
            if (currentPageId > 0 && $scope.view.mainBrandKit) {
                $scope.layout.brandKit = JSON.parse(JSON.stringify($scope.view.mainBrandKit))
            }
            $scope.view.mappingKinds = $scope.layout.dynamicMap || $scope.layout.mapping

            // Set type classification
            if (!$scope.layout.classification.shape) {
                $scope.layout.classification.shape = 'geometric'
            }
            if (!$scope.layout.classification.dimension) {
                $scope.layout.classification.dimension = 'flat'
            }
            if (!$scope.layout.classification.gender) {
                $scope.layout.classification.gender = 'unisex'
            }
            $scope.loadFonts(response.data.layout.fonts)
            $scope.selectType('text')
            $scope.render()
        })
        .catch(function(error) {
            console.error('Error getting import layout', error)
        })
    }

    function parseBrandKit(brandKit, currentPage) {
        if (currentPage === 0 && $scope.view.mainBrandKit) {
            return JSON.parse(JSON.stringify($scope.view.mainBrandKit))
        }

        if (!brandKit) {
            brandKit = {}
        }
        if (!brandKit.colors) {
            brandKit.colors = {}
        }
        if (!brandKit.fonts) {
            brandKit.fonts = {}
        }
        return brandKit
    }

    $scope.searchStyles = function() {
        api.getStyles({
            area: $scope.layout.classification.area,
        }).then(function(response) {
            $scope.view.styles = response.data.styles
            $scope.view.images = response.data.images
            $timeout(angular.noop)
        })
        .catch(function(error) {
            console.error('Error getting styles', error)
        })
    }

    $scope.selectImage = function(image) {
        for (let mapping in $scope.view.mappingKinds) {
            if ($scope.view.mappingKinds[mapping] === image.kind) {
                let element = findElementsById($scope.layout.tree, mapping)
                if (element) {
                    element.src = image.src
                    element.computed['background-repeat'] = 'no-repeat'
                }
                break
            }
        }
        $scope.render()
    }

    $scope.selectStyle = function(style) {
        $scope.view.theme.pallete.main = style.brandKit.colors.main
        $scope.view.theme.pallete.text = style.brandKit.colors.text
        $scope.view.theme.pallete.highlight = style.brandKit.colors.highlight
        $scope.refresh()
        if (!$scope.view.currentContent.title) {
            $scope.previewLayout()
        }
        $scope.view.selectedStyle = style
    }

    $scope.applyStyle = function() {
        // Replace images if there are imagens
        if (!$scope.view.originalLayout) {
            $scope.view.originalLayout = JSON.parse(JSON.stringify($scope.layout.tree))
        }
        let layoutString = JSON.stringify($scope.view.originalLayout || $scope.layout.tree, null, 2)
        let layoutBrandKit = $scope.layout.brandKit

        // Replace colors
        for (let color in layoutBrandKit.colors) {
            if (color == 'pallete') {
                continue
            }
            let rgb = hexToRgb(layoutBrandKit.colors[color])
            rgb = [rgb.red, rgb.green, rgb.blue]
            let rgbString = `rgb(${rgb.join(', ')})`
            // Escape regex
            rgbString = rgbString.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
            layoutString = layoutString.replace(new RegExp(rgbString, 'gm'), '###' + color + '###')
        }

        for (let color in layoutBrandKit.colors) {
            if (color == 'pallete') {
                continue
            }
            let replacedColor = $scope.view.selectedStyle.brandKit.colors[color]
            replacedColor = hexToRgb(replacedColor)
            replacedColor = `rgb(${replacedColor.red}, ${replacedColor.green}, ${replacedColor.blue})`
            layoutString = layoutString.replace(new RegExp('###' + color + '###', 'gm'), replacedColor)
        }

        // Replace fonts
        for (let font in layoutBrandKit.fonts) {
            layoutString = layoutString.replace(new RegExp(layoutBrandKit.fonts[font], 'gm'), '###' + font + '###')
        }

        for (let font in layoutBrandKit.fonts) {
            layoutString = layoutString.replace(new RegExp('###' + font + '###', 'gm'), $scope.view.selectedStyle.brandKit.fonts[font])
        }

        $scope.layout.brandKit = JSON.parse(JSON.stringify($scope.view.selectedStyle.brandKit))
        $scope.layout.tree = JSON.parse(layoutString)

        $scope.render()
    }

    $scope.editTemplate = function(templateId) {
        api.editTemplate(templateId).then(function(response) {
            console.log('Edit template', response.data)
            $scope.view.pages = response.data.layouts.map(function(layout, index) {
                return {
                    // TODO - get text
                    title: `Slide ${index + 1}`,
                    id: index,
                    layoutId: layout._id,
                }
            })

            // TODO - Refactor
            $scope.layouts = response.data.layouts.map(function(l, index) {
                let translation = l.data.translation
                if (!translation) {
                    translation = {
                        original: 'en'
                    }
                }

                return {
                    id: l._id,
                    mapping: l.data.mapping,
                    classification: l.data.classification,
                    brandKit: parseBrandKit(l.data.brandKit, index),
                    tree: l.data.layout,
                    translation: translation,
                }
            })
            $scope.view.mappingKinds = response.data.layouts[0].data.mapping
            $scope.selectPage($scope.view.pages[0])
            $scope.selectType('text')
            $timeout(angular.noop)
        })
        .catch(function(error) {
            console.error('Error getting import layout', error)
        })
    }

    $scope.parsePost = function(item, layout) {
        let itemConfig = {}
        //let itemTheme = Object.assign({}, $scope.state.data.theme)
        let itemTheme = $scope.view.theme

        // Keep the original theme for scheduled posts
        if ($scope.state && $scope.state.data && $scope.state.data.global && $scope.state.data.global.content) {
            itemConfig.global = Object.assign({}, $scope.state.data.global)
        }
        if (!itemTheme.global) {
            itemTheme.global = {}
        }
        if ($scope.layout.brandKit) {
            itemTheme.brandKit = $scope.layout.brandKit
        }
        itemTheme.global.showOriginalText = true
        let parsedPost = parserService.convertLayout(
            layout,
            item,
            itemTheme,
            //getContentForItem(item, itemConfig, 0),
            //getThemeForItem(itemTheme, item, 0)
        );
        return parsedPost
    }

    let debounceVisual = null
    $scope.render = function() {
        $scope.parsedPosts = []

        let parsedPost = $scope.parsePost($scope.view.currentContent, $scope.layout.tree) // TODO - Refactor

        $scope.parsedPosts.push(parsedPost)
        $timeout(angular.noop)

        if (debounceVisual) {
            clearTimeout(debounceVisual)
        }
        debounceVisual = setTimeout(function() {
            $scope.visualInit()
        }, 100)
    }

    $scope.load = function() {
        $scope.view.loading = true
        $timeout(angular.noop)
    }
    $scope.finish = function() {
        $scope.view.loading = false
        $timeout(angular.noop)
    }

    $scope.cleanImport = function() {
        $scope.view = JSON.parse(JSON.stringify(INITIAL_VIEW))
    }

    $scope.parseLayout = function(forceFetch) {
        if (!$scope.importURL) return

        $scope.isDuplicate = false
        $scope.cleanImport()

        $scope.load()

        api.processImport({
            url: $scope.importURL,
            refresh: !!forceFetch,
        }).then(function(response) {
            if (response.data.result.pages) {
                $scope.createPages(response.data.result.pages)
            }
            $scope.importId = response.data.result.id
            $scope.openImport(response.data.result.id)
        })
        .catch(function(error) {
            console.error('Error parsing layout', error)
            showError(gettext('error.generic'))
        })
        .finally(function() {
            $scope.finish()
        })
    }

    $scope.parseAsStyle = function() {
        $scope.importAsStyle = true
        $scope.getCategories()
        $scope.parseLayout()
        $timeout(function() {
            $scope.selectType('colors')
        }, 500)
    }

    $scope.visualInit = function() {
        visual.init({
            select: function(element) {
                $timeout(function() {
                    $scope.selectLayerById(element.elementId)
                })
                console.log('Select', element)
                $timeout(angular.noop)
            },
            deselect: function(element) {
                console.log('Deselect', element)
                $timeout(function() {
                    $scope.view.selectLayer = null
                })
            },
            update: function(change) {
                console.log('Change', change)
                //$scope.changeSettings()
                $timeout(angular.noop)
            },
            render: function() {
                console.log('Render')
                //$scope.refreshVisual()
            }
        }, {
            cardId: -1,
            theme: {
                settings: {}
            }
        }, {
            wrapperId: 'importer-wrapper',
            useOriginalIds: true,
        })
    }
    $scope.getHueFilter = function() {
        if (!$scope.selectedColor) return {}
        let baseColor = HEXtoHSL('#533920') //returns array [h,s,l]
        let selectedColor = HEXtoHSL($scope.selectedColor) //returns array [h,s,l]
        // Diff in hue
        let hueDiff = selectedColor[0] - baseColor[0]
        let saturationDiff = selectedColor[1]/baseColor[1]
        let lightnessDiff = selectedColor[2]/baseColor[2]
        lightnessDiff = 1
        return {
            'filter': `hue-rotate(${hueDiff}deg) saturate(${saturationDiff}) brightness(${lightnessDiff})`
        }
    }

    $scope.loadFonts = function(fonts) {
        for (let font in fonts) {
            let fontFace = new FontFace(font, `url(${fonts[font]})`);
            document.fonts.add(fontFace);
            fontFace.load().then(function(loadedFont) {
                //console.log('Font loaded', loadedFont);
            }).catch(function(error) {
                console.error('Font failed to load', error);
            });
        }
    }

    $scope.importStyle = function() {
        $scope.importLayout('style')
    }

    $scope.duplicateStyle = function() {
        if (!$scope.view.selectedStyle) {
            return
        }
        $scope.isDuplicate = true
        $scope.importLayout('style', $scope.view.selectedStyle.brandKit)
    }

    $scope.importLayout = function(kind, forceBrandKit = null) {
        console.log('Importing layout')

        $scope.view.editingLanguage = $scope.layout.translation.original
        $scope.onChangeEditingLanguage()

        let currentPage = $scope.view.pages.find(p => p.active)
        let firstPage = $scope.view.pages[0]
        let existingLayoutId = currentPage.layoutId
        let params = {
            layout: JSON.parse(JSON.stringify($scope.layout)),
            mappingKinds: $scope.view.mappingKinds
        }
        params.layout.page = currentPage.id
        if (existingLayoutId && !forceBrandKit) {
            params._id = existingLayoutId
        }
        let currentBrandKit = forceBrandKit || params.layout.brandKit
        params.layout.brandKit = parseBrandKit(currentBrandKit, currentPage.id)

        if (currentPage.id === 0 && !forceBrandKit) {
            $scope.view.mainBrandKit = params.layout.brandKit
        }

        if (currentPage.id > 0) {
            // First pages need to be saved first
            if (!firstPage.layoutId) {
                alert('Please save the first page first')
                return
            }
            params.parentId = firstPage.layoutId
        }
        if ($scope.projectId) {
            params.projectId = $scope.projectId
        }
        if (kind && kind === 'style') {
            params.importAsStyle = true
        }
        if ($scope.isDuplicate) {
            params.duplicate = true
        }

        $scope.load()
        api.saveImport(params).then(function(response) {
            if (response && response.data && response.data.id) {
                showSuccess(gettext('label.import_layout_success'))
                currentPage.layoutId = response.data.id
            } else {
                showError(gettext('error.generic'))
            }
        })
        .catch(function(error) {
            console.error('Error importing layout', error)
        })
        .finally(function() {
            $scope.finish()
        })
    }

    function findElementsByIds(tree, ids) {
        let elements = []
        for (let element of tree.elements) {
            if (ids.includes(element.id)) {
                elements.push(element);
            }
            if (element.elements) {
                elements = elements.concat(findElementsByIds(element, ids));
            }
        }
        return elements;
    }

    function findElementsById(tree, id) {
        let elements = findElementsByIds(tree, [id]);
        if (elements.length) {
            return elements[0];
        }
        else {
            return null;
        }
    }

    function removeByIds(tree, ids) {
        for (let i = tree.elements.length - 1; i >= 0; i--) {
            let element = tree.elements[i];
            if (ids.includes(element.id)) {
                tree.elements.splice(i, 1);
            } else if (element.elements) {
                removeByIds(element, ids);
            }
        }
    }

    function getActiveElement() {
        if (!$scope.view.selectedLayer) {
            return null
        }
        return findElementsById($scope.layout.tree, $scope.view.selectedLayer.id)
    }

    $scope.removePage = function() {
        // Find active page
        let currentPage = $scope.view.pages.find(p => p.active)
        if (!currentPage) {
            return
        }
        if (!currentPage.layoutId) {
            return
        }
        if (confirm('Are you sure you want to remove this page?')) {
            api.removeLayout(currentPage.layoutId).then(function(response) {
                $scope.editTemplate($scope.view.pages[0].layoutId)
            }).catch(function(error) {
                console.error('Error removing layout', error)
            })
        }
    }

    $scope.duplicatePage = function() {
        let newPage = {
            // TODO - get text
            title: `Slide ${$scope.view.pages.length + 1}`,
            id: $scope.view.pages.length,
        }

        $scope.layouts[newPage.id] = JSON.parse(JSON.stringify($scope.layout))
        $scope.layouts[newPage.id].page = newPage.id
        $scope.view.pages.push(newPage)

        $scope.selectPage(newPage)
    }

    $scope.translateLayout = function() {
        let params = {
            source: $scope.layout.translation.original,
            target: $scope.view.editingLanguage,
        }

        let texts = $scope.layout.translation[$scope.layout.translation.original]
        if (!texts) {
            return
        }

        const TRANSLATION_MAP = {
            'pt': {
                'address': 'Avenida Brasil, 1723',
                'phone': '+55 11 1234-5678',
                'website': 'www.meusite.com.br',
                'email': 'contato@negocio.com.br',
            },
        }
        let fixedTranslation = {}
        // Ignore some texts that have the mapping above $scope.view.mappingKinds
        for (let key in texts) {
            let kind = $scope.view.mappingKinds[key]
            if (kind && TRANSLATION_MAP[params.target] && TRANSLATION_MAP[params.target][kind]) {
                fixedTranslation[key] = TRANSLATION_MAP[params.target][kind]
                delete texts[key]
            }
        }

        params.texts = texts
        api.translateTexts(params).then(function(response) {
            let translation = response.data
            translation = Object.assign(translation, fixedTranslation)
            // Only keep translation keys that exist in the original
            for (let key in translation) {
                document.querySelectorAll(`[data-text-import-id="${key}"]`).forEach(function(element) {
                    element.innerHTML = translation[key]
                    $scope.layout.translation[$scope.view.editingLanguage][key] = translation[key]
                })
            }

            $scope.updateTextValues()
            $scope.onChangeEditingLanguage()
        })
        .catch(function(error) {
            console.error('Error translating texts', error)
        })
    }

    // Editor actions
    $scope.changePostSize = function(size) {
        $scope.view.postSize = size

        let mapSizes = {
            'square': {
                width: 1,
                height: 1
            },
            'portrait': {
                width: 1,
                height: 1.25
            },
            'story': {
                width: 1,
                height: 1.777777777778
            },
        }
        console.log('Changing size', size)
        $scope.view.theme.size = mapSizes[size]
        $scope.render()
    }

    $scope.selectLayer = function(layer) {
        $scope.view.selectedLayer = layer

        if (!visual) {
            return
        }
        visual.selectElement({
            elementId: layer.id,
            cardId: '0',
        })
    }

    function findIndexBackgroundToInsert() {
        let index = 0
        for (let i = 0; i < $scope.layout.tree.elements.length; i++) {
            if ($scope.layout.tree.elements[i].type === 'container' && index > 0) {
                index = i
                break
            }
        }
        return index
    }

    $scope.unsetImage = function(layer) {
        if (layer.type === 'image') {
            delete layer.src
            $scope.render()
        }
    }

    $scope.removeElement = function() {
        let element = getActiveElement()
        if (!element) {
            return
        }
        removeByIds($scope.layout.tree, [element.id])
        $scope.updateLayers()
        $scope.render()
    }

    $scope.moveTo = function(kind) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        removeByIds($scope.layout.tree, [element.id])

        let indexToInsert = findIndexBackgroundToInsert()
        if (kind == 'background') {
            indexToInsert -= 1
            $scope.layout.tree.elements.splice(indexToInsert, 0, element)
        } else if (kind == 'foreground') {
            $scope.layout.tree.elements.push(element)
        }

        $scope.render()
    }

    $scope.createTextWrapperContainer = function() {
        let container = {
            id: 'text',
            type: 'container',
            align: 'center',
            hpos: 'center',
            vpos: 'center',
            elements: [],
            computed: {},
        }

        let contentContainerIndex = null
        for (let i = $scope.layout.tree.elements.length - 1; i >= 0; i--) {
            if ($scope.layout.tree.elements[i].type === 'container') {
                contentContainerIndex = i
                break
            }
        }
        if (!contentContainerIndex) {
            alert('No container found')
            return
        }
        function getElementByType(kind) {
            for (let key in $scope.view.mappingKinds) {
                if ($scope.view.mappingKinds[key] === kind) {
                    let element = findElementsById($scope.layout.tree, key)
                    if (element) {
                        return element
                    }
                }
            }
            return null
        }
        function cleanElements(element) {
            // Remove width, top, left, right, bottom from computed
            element.computed.width = '100%'
            delete element.computed.height
            delete element.computed.top
            delete element.computed.left
            delete element.computed.right
            delete element.computed.bottom
            element.computed.position = 'relative'
        }

        let descriptionEl = getElementByType('description')
        let titleEl = getElementByType('title')
        if (!descriptionEl || !titleEl) {
            alert('No title or description found')
            return
        }

        function getBBox(style) {
            return {
                x: parseFloat(style.left),
                y: parseFloat(style.top),
                width: parseFloat(style.width),
                height: parseFloat(style.height),
            }
        }
        function joinBBox(bbox1, bbox2) {
            let x = Math.min(bbox1.x, bbox2.x)
            let y = Math.min(bbox1.y, bbox2.y)
            let width = Math.max(bbox1.x + bbox1.width, bbox2.x + bbox2.width) - x
            let height = Math.max(bbox1.y + bbox1.height, bbox2.y + bbox2.height) - y
            return {
                x: x,
                y: y,
                width: width,
                height: height,
            }
        }
        // Update container bbox to be the combined bbox of title and description
        let bboxTitle = getBBox(titleEl.computed)
        let bboxDescription = getBBox(descriptionEl.computed)

        let bbox = joinBBox(bboxTitle, bboxDescription)
        container.computed.width = bbox.width + 'px'
        container.computed.height = bbox.height + 'px'
        container.computed.top = bbox.y + 'px'
        container.computed.left = bbox.x + 'px'

        cleanElements(descriptionEl)
        cleanElements(titleEl)

        titleEl.fitToParent = true

        container.elements.push(titleEl)
        container.elements.push(descriptionEl)

        // Remove from tree
        removeByIds($scope.layout.tree, [titleEl.id, descriptionEl.id])

        $scope.layout.tree.elements[contentContainerIndex].elements.push(container)
        $scope.onInputsChange()
    }

    $scope.moveToBackground = function() {
        $scope.moveTo('background')
    }

    $scope.moveToFront = function() {
        $scope.moveTo('foreground')
    }

    $scope.alignTop = function() {
        let element = getActiveElement()
        if (!element) {
            return
        }

        $scope.moveToBackground()

        delete element.computed.bottom
        element.computed.top = '0px'
        $scope.render()
    }

    $scope.alignBottom = function() {
        $scope.moveToBackground()
        let element = getActiveElement()
        if (!element) {
            return
        }

        delete element.computed.top
        element.computed.bottom = '0px'
        $scope.render()
    }

    $scope.makeFullHeight = function() {
        $scope.moveToBackground()
        let element = getActiveElement()
        if (!element) {
            return
        }

        let aspectRatio = parseFloat(element.computed.width) / parseFloat(element.computed.height)

        element.computed.width = 'auto'
        element.computed['aspect-ratio'] = aspectRatio
        element.computed.height = '100%'
        $scope.render()
    }

    $scope.alignHorizontal = function(type) {
        let element = getActiveElement()
        if (!element) {
            return
        }

        if (type === 'left') {
            delete element.computed.right
            element.computed.left = '0px'
        } else if (type === 'right') {
            delete element.computed.left
            element.computed.right = '0px'
        } else {
            delete element.computed.left
            delete element.computed.right
            let width = parseFloat(element.computed.width)
            let left = (BASE_SIZE - width) / 2
            element.computed.left = left + 'px'
        }
        $scope.refresh()
    }

    $scope.alignVertical = function(type) {
        console.log('Aligning vertical', type)
        let element = getActiveElement()
        if (!element) {
            return
        }

        if (type === 'top') {
            delete element.computed.bottom
            element.computed.top = '0px'
        } else if (type === 'bottom') {
            delete element.computed.top
            element.computed.bottom = '0px'
        } else {
            delete element.computed.top
            delete element.computed.bottom
            let height = parseFloat(element.computed.height)
            let top = (BASE_SIZE - height) / 2
            element.computed.top = top + 'px'
        }
        $scope.refresh()
    }

    $scope.alignTextVertical = function(type) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        element.computed.display = 'flex'
        if (type === 'top') {
            element.computed['align-items'] = 'flex-start'
        } else if (type === 'bottom') {
            element.computed['align-items'] = 'flex-end'
        } else if (type === 'center') {
            element.computed['align-items'] = 'center'
        }
        $scope.refresh()
    }

    $scope.alignTextHorizontal = function(type) {
        let element = getActiveElement()
        if (!element) {
            return
        }
        element.computed.display = 'flex'
        if (type === 'left') {
            element.computed['justify-content'] = 'flex-start'
        } else if (type === 'right') {
            element.computed['justify-content'] = 'flex-end'
        } else if (type === 'center') {
            element.computed['justify-content'] = 'center'
        }
        $scope.refresh()
    }

    $scope.hasProperty = function(property) {
        let element = getActiveElement()
        if (!element) {
            return false
        }
        return property in element.computed
    }

    $scope.deselectObject = function() {
        $scope.view.selectedLayer = null
        visual.deselectElement()
        $scope.refresh()
    }

    $scope.previewLayout = function() {
        if ($scope.view.currentContent.title) {
            $scope.view.currentContent = {}
            if ($scope.view.theme.global && $scope.view.theme.global.applyRotation) {
                delete $scope.view.theme.global.applyRotation
            }
        } else {
            $scope.view.currentContent = SAMPLE_CONTENT
            if (!$scope.view.theme.global) {
                $scope.view.theme.global = {}
            }
            $scope.view.theme.global.applyRotation = true
        }
        $scope.render()
    }

    $scope.addText = function() {
        // TODO - Find it
        const contentContainerIndex = 2
        let fontFamily = ''

        function getFontFamily(kind) {
            for (let key in $scope.view.mappingKinds) {
                if ($scope.view.mappingKinds[key] === kind) {
                    let element = findElementsById($scope.layout.tree, key)
                    if (element && element.computed['font-family']) {
                        return element.computed['font-family']
                    }
                }
            }
            return null
        }
        // Try description, title, fixed_text
        fontFamily = getFontFamily('description')
        if (!fontFamily) {
            fontFamily = getFontFamily('title')
        }
        if (!fontFamily) {
            fontFamily = getFontFamily('fixed_text')
        }

        let newElement = {
            // TODO
            id: 'p-' + Math.random().toString(36).substr(2, 5),
            type: 'p',
            value: '@profile',
            computed: {
                'font-family': fontFamily,
                position: 'absolute',
                width: '100px',
                height: '15px',
                left: '0px',
                top: '0px',
                'font-size': '12px',
                'line-height': '12px',
                'text-align': 'left',
            }
        }
        $scope.layout.tree.elements[contentContainerIndex].elements.push(newElement)
        $scope.onInputsChange()
        $scope.selectLayerById(newElement.id)
    }

    $scope.onLayerChange = function(layer) {
        console.log('Layer change', layer)
    }

})